import { fetchFromAPI } from 'utils/api';

export function getUnreadUserNotificationsCount(userId, groupName) {
  return fetchFromAPI(`/users/${userId}/notifications/unread_notifications_count`, {
    params: { group: groupName },
  });
}
